import { Injectable } from "@angular/core";
import { ConfirmModalContentComponent } from "app/shared/components/confirm-modal/confirm-modal.component";
import {
  NgbModalOptions,
  NgbModal
} from "@ng-bootstrap/ng-bootstrap/modal/modal";
import { PatientService } from "../patient.service";
import { Store } from "@ngrx/store";
import { Router, ActivatedRoute, NavigationExtras } from "@angular/router";
import { UtilService } from "../../util/util.service";
import { SetPatientAction } from "app/shared/actions/patient.actions";

@Injectable()
export class DuplicateFinderService {
  public duplicatePatients: any;
  public patient: any;
  public redirect: string;

  constructor(
    private patientService: PatientService,
    private modalService: NgbModal,
    public router: Router,
    public route: ActivatedRoute,
    private utilService: UtilService,
    private store: Store<any>
  ) {}

  confirmDuplicatePatient(dob, pt, mode, id?) {
    this.patientService
      .getDuplicatePatients(pt.LastName, pt.FirstName, dob)
      .subscribe(res => {
        let recordsArray = [];
        const foundRecords = res.json() || [];
        foundRecords.forEach(element => {
          recordsArray.push(
            `${element.FirstName} ${element.LastName} (DOB: ${element.Dob})`
          );
        });

        this.duplicatePatients = recordsArray;
        if (
          (mode === "edit-mode" &&
            this.isDuplicatePatientExists(foundRecords)) ||
          (mode === "new-mode" && recordsArray.length > 0)
        ) {
          this.openModal(dob, pt, id);
        } else {
          this.update(dob, pt);
        }
      });
  }

  isDuplicatePatientExists(patients): boolean {
    let isCurrPatientExist: boolean;
    this.store
      .select("patient")
      .first()
      .subscribe(data => {
        const { FirstName, LastName } = data;
        if (patients[0]) {
          isCurrPatientExist =
            patients[0].FirstName === FirstName &&
            patients[0].LastName === LastName &&
            patients.length === 1
              ? false
              : true;
        }
      });
    return isCurrPatientExist;
  }

  openModal(dob, pt, id?) {
    const options: NgbModalOptions = {
      backdrop: "static",
      windowClass: "backdrop",
      keyboard: true
    };
    const modalRef = this.modalService.open(
      ConfirmModalContentComponent,
      options
    );
    const dupPTLength = this.duplicatePatients.length;
    modalRef.componentInstance.title = `${dupPTLength} Duplicate ${
      dupPTLength > 1 ? "Patients" : "Patient"
    }  Found!`;
    modalRef.componentInstance.bodyText = this.duplicatePatients;
    modalRef.componentInstance.cancelButtonText = "CANCEL";
    modalRef.componentInstance.successButtonText = "PROCEED";
    modalRef.componentInstance.displayCornerClose = true;
    modalRef.componentInstance.backdrop = true;
    modalRef.componentInstance.note = true;

    modalRef.result.then(
      res => {
        if (res === "Okay") {
          this.update(dob, pt);
        }
      },
      dismiss => {
        id
          ? this.router.navigate([`/patients/${id}/detail`])
          : this.router.navigate(["patients/create/profile"], {
              relativeTo: this.route
            });
      }
    );
  }

  update(dob, pt) {
    pt = {
      ...pt,
      BirthDay: String(dob.day),
      BirthMonth: String(dob.month),
      BirthYear: String(dob.year)
    };

    this.store.dispatch(new SetPatientAction(pt, this.utilService));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/patient/duplicate-finder/duplicate-finder.service.ts